'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'LandRestService',
    function($modal, LandRestService) {
        return {
            select: select,
            edit: edit,
            create: create,
            getExternalURI: getExternalURI,
            api: LandRestService,
        };

        function select(land, filters) {
            return $modal.open({
                template: require('../view/land-modal-select.html'),
                controller: 'LandModalSelectController',
                size: 'lg',
                backdrop: false,
                resolve: {
                    land: function() {
                        return land != null ? land : {};
                    },
                    landFilters: function() {
                        return filters != null ? filters : [];
                    },
                },
            });
        }

        function create(def) {
            return $modal.open({
                template: require('../view/land-modal-create.html'),
                controller: 'LandModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    land: function() {
                        return {
                            municipality: (function(def) {
                                if (def != null && def.municipality != null) return def.municipality;
                            })(def),
                            category: (function(def) {
                                if (def != null && def.category != null) return def.category;
                            })(def),
                            area: (function(def) {
                                if (def != null && def.area != null) return def.area;
                            })(def),
                        };
                    },
                },
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/land-modal-create.html'),
                controller: 'LandModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    land: function() {
                        return item;
                    },
                },
            });
        }

        function getExternalURI(item) {
            return encodeURI('http://pkk5.rosreestr.ru/#&text=' + item.regNum + '&type=1&app=search&opened=1');
        }
    }];
